import { Component, inject, input, output, signal, TemplateRef, viewChild } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";

import { Constants } from "../../../../constants/constants";
import { FileInputType } from "../../../../constants/enums";
import {
  AttachFile,
  PropTypeModelType,
  WorkflowDecisionModelType,
  WorkflowMonitoringItemModelType,
} from "../../../../models";
import { LanguageService, WorkflowsApiService } from "../../../../services";
import { FormInputFileComponent } from "../../../form";
import { WfOverrideDecisionComponent } from "../wf-override-decision/wf-override-decision";

@Component({
  selector: "adaa-wf-override-decision-modal",
  imports: [TranslatePipe, ReactiveFormsModule, FontAwesomeModule, FormInputFileComponent, WfOverrideDecisionComponent],
  templateUrl: "./wf-override-decision-modal.html",
  styleUrl: "./wf-override-decision-modal.scss",
})
export class WfOverrideDecisionModalComponent {
  private readonly _workflowsApiService = inject(WorkflowsApiService);
  private readonly _translateService = inject(TranslateService);
  private readonly _languageService = inject(LanguageService);
  private readonly _modalService = inject(NgbModal);

  actionCategories = input<PropTypeModelType[]>([]);
  objectName = input<string | undefined>();
  closeModal = output<void>();

  content = viewChild.required<TemplateRef<unknown>>("content");

  data = signal<WorkflowMonitoringItemModelType | undefined>(undefined);
  decision = signal<Partial<WorkflowDecisionModelType> | undefined>(undefined);
  attachment = signal<AttachFile | null>(null);

  readonly removeIcon = faTrash;
  allowedFiles: FileInputType[] = [
    FileInputType.txt,
    FileInputType.pdf,
    FileInputType.doc,
    FileInputType.docx,
    FileInputType.xls,
    FileInputType.xlsx,
    FileInputType.png,
    FileInputType.jpeg,
    FileInputType.jpg,
  ];

  wfActionType = Constants.WF_ACTION_DECISION;
  modalRef: NgbModalRef;
  commentForm: FormGroup<{ comment: FormControl<string | undefined>; categoryId: FormControl<number | undefined> }>;

  public get isButtonsDisabled(): boolean {
    return (this.decision()?.categorizedComments ?? []).length < 1;
  }

  public submitDecision(actionType: number) {
    this.decision.update((decision) => ({
      ...decision,
      stepDecision: actionType,
      itemAttachmentId: this.attachment()?.id,
    }));

    this._workflowsApiService.submitWorkflowDecision(this.decision() as WorkflowDecisionModelType).subscribe({
      next: () => {
        this.data.set(undefined);
        this.decision.set(undefined);
        this.attachment.set(null);
        this.closeModal.emit();
      },
    });
  }

  public open(workflowItem: WorkflowMonitoringItemModelType) {
    this.data.set(workflowItem);

    this.modalRef = this._modalService.open(this.content(), {
      backdrop: "static",
      keyboard: false,
      animation: true,
      scrollable: false,
      ariaLabelledBy: this._translateService.instant("workflow.override_monitored_decision"),
      centered: true,
      modalDialogClass: `modal-${this._languageService.direction()}`,
      size: "lg",
      beforeDismiss: () => {
        this.data.set(undefined);
        this.decision.set(undefined);
        this.attachment.set(null);
        return true;
      },
    });
  }
}
